const PrivacyPolicy = () => {
    return <><h1>Privacy Policy</h1>

    <p>At DRX Sportnet, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and disclose your information when you use the DRX Sportnet application ('App') provided by DRX Wear ('we,' 'us,' or 'our') through the Google Play Store. By downloading, installing, or using the App, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy. Please read this Privacy Policy carefully before using the App.</p>

    <h2>Information We Collect</h2>

    <h3>1. Personal Information:</h3>
    <p>We may collect personal information, such as your name, email address, and location, when you voluntarily provide it to us during the registration process or while using certain features of the App.</p>

    <h3>2. Device Information:</h3>
    <p>We may collect information about your device, including but not limited to the device type, operating system, unique device identifiers, and IP address, to ensure the proper functioning of the App and improve our services.</p>

    <h2>Use of Information</h2>

    <h3>1. We may use the information we collect to:</h3>
    <ul>
        <li>Provide and improve the App's functionality and user experience.</li>
        <li>Communicate with you, respond to your inquiries, and provide customer support.</li>
        <li>Personalize and customize your experience with the App.</li>
        <li>Send you updates, notifications, and promotional messages related to the App or our services.</li>
    </ul>

    <h2>Sharing of Information</h2>

    <h3>1. We may share your information with third parties in the following circumstances:</h3>
    <ul>
        <li>With your consent: We may share your information with third parties when you explicitly consent to such sharing.</li>
        <li>Service Providers: We may engage third-party service providers to perform certain functions on our behalf, such as data storage, hosting, and analytics. These service providers will have access to your information solely for the purpose of providing their services to us.</li>
        <li>Legal Compliance: We may disclose your information to comply with applicable laws, regulations, or legal processes, or to protect our rights, property, or safety.</li>
    </ul>

    <h2>Security</h2>

    <h3>1. We implement reasonable security measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.</h3>

    <h2>Children's Privacy</h2>

    <h3>1. The App is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us, and we will take appropriate steps to remove such information from our systems.</h3>

    <h2>Third-Party Links and Services</h2>

    <h3>1. The App may contain links to third-party websites, services, or advertisements. We are not responsible for the privacy practices of such third parties. We encourage you to review the privacy policies of those third parties before providing any personal information.</h3>

    <h2>Changes to this Privacy Policy</h2>

    <h3>1. We reserve the right to update or modify this Privacy Policy at any time without prior notice. We will post the updated Privacy Policy on the App and indicate the date of the latest revision. Your continued use of the App after any modifications to the Privacy Policy constitutes your acceptance of the revised Privacy Policy.</h3>

    <h2>Contact Us</h2>

    <h3>1. If you have any questions, concerns, or requests regarding this Privacy Policy or the App's privacy practices, please contact us at <a href="mailto:support@drxasia.com">support@drxasia.com</a>.</h3>

    <p>By using the DRX Sportnet App, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy. If you do not agree with this Privacy Policy, please refrain from using the App.</p>

    <p>Thank you for using DRX Sportnet!</p></>
}

export default PrivacyPolicy;